import {CalculationRunOptions} from '../calculation-run.options';
import {
  advancedFormGroup,
  advancedFormControl,
  FormControlTypeEnum,
} from '@magieno/common';
import {CalculationKeynameEnum} from '../../../enums/calculations/calculation-keyname.enum';
import {FieldTypeEnum} from '../../../enums/field-type.enum';
import {IsInt, IsNotEmpty, Max, Min, ValidateNested} from '@pristine-ts/class-validator';
import {ErrorMessageBuilder} from '../../../builders/error-message.builder';
import {type} from '@pristine-ts/data-mapping-common';
import {IncomeTaxPersonalInRrspOptions} from './income-tax/personal/income-tax-personal-in-rrsp.options';
import { translationBaseKey } from '../../../decorators/translation-base-key.decorator';

@translationBaseKey('rrsp-options')
export class RrspOptions extends CalculationRunOptions {

  @advancedFormControl({
    type: FormControlTypeEnum.Hidden,
  })
  calculationKeyname: CalculationKeynameEnum = CalculationKeynameEnum.Rrsp;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Quelle est l\'année?',
        en: 'What is the year?',
      },
      tooltip: {
        fr: 'L\'année fiscale pour laquelle les calculs sont effectués.',
        en: 'The tax year for which the calculations are performed.',
      },
    },
    fieldType: FieldTypeEnum.Number,
    type: FormControlTypeEnum.Select,
    items: [
      {
        label: {
          fr: '2023',
        },
        id: 2023,
      },
      {
        label: {
          fr: '2024',
        },
        id: 2024,
      },
      {
        label: {
          fr: '2025',
        },
        id: 2025,
      },
    ],
  })
  @IsInt({buildErrorMessage: ErrorMessageBuilder.build})
  @IsNotEmpty({buildErrorMessage: ErrorMessageBuilder.build})
  @Min(2023, {buildErrorMessage: ErrorMessageBuilder.build})
  @Max(2025, {buildErrorMessage: ErrorMessageBuilder.build})
  year: number;

  @type(() => new IncomeTaxPersonalInRrspOptions())
  @advancedFormGroup({
    classType: IncomeTaxPersonalInRrspOptions,
  })
  @ValidateNested()
  personalIncomeTaxOptions: IncomeTaxPersonalInRrspOptions = new IncomeTaxPersonalInRrspOptions();
}